import { useLang } from "@/lib/i18n";
import { ArrowRight } from "lucide-react";

export default function CsatStory({ csat }) {
  const { t } = useLang();
  if (!csat) return null;
  return (
    <section
      data-testid="csat-story"
      className="py-10 lg:py-14 border-t border-[#e5e0d8] bg-[#f2ece4]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="max-w-3xl">
          <div className="font-mono-label text-[11px] text-[#9a7218]">
            {t("Insight → action")}
          </div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl leading-tight text-[#14352a]">
            {t(csat.headline)}
          </h2>
          <p className="mt-3 text-sm text-[#55625b] leading-relaxed">{t(csat.intro)}</p>
        </div>

        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {csat.scores.map((s, i) => (
            <div key={i} data-testid={`csat-score-${i}`} className="p-4 bg-white border border-[#e5e0d8]">
              <div className="font-display text-3xl text-[#14352a]">{s.value}</div>
              <div className="mt-1 font-mono-label text-[8px] text-[#86928a] leading-snug">{s.label}</div>
            </div>
          ))}
        </div>

        <ol className="mt-6 space-y-3">
          {csat.loops.map((l, i) => (
            <li
              key={i}
              data-testid={`csat-loop-${i}`}
              className="grid md:grid-cols-[1fr_auto_1fr] items-stretch gap-3 md:gap-4"
            >
              <div className="p-5 bg-white border border-[#e5e0d8]">
                <div className="font-mono-label text-[8px] text-[#86928a]">{t("Insight")} {i + 1}</div>
                <p className="mt-1.5 text-sm text-[#14352a] leading-relaxed">{t(l.insight)}</p>
              </div>
              <div className="hidden md:grid place-items-center">
                <span className="h-9 w-9 rounded-full btn-guide grid place-items-center">
                  <ArrowRight className="h-4 w-4" />
                </span>
              </div>
              <div className="p-5 bg-[#14352a] text-[#faf8f5] border-l-4 border-[#d9a92e]">
                <div className="font-mono-label text-[8px] text-[#d9a92e]">{t("Action")}</div>
                <p className="mt-1.5 text-sm leading-relaxed text-[#faf8f5]/90">{t(l.action)}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-6 grid sm:grid-cols-2 gap-4">
          {csat.quotes.map((q, i) => (
            <figure key={i} className="p-4 bg-white/70 border border-[#e5e0d8]">
              <blockquote className="font-display italic text-base text-[#14352a] leading-snug">
                &ldquo;{q.text}&rdquo;
              </blockquote>
              <figcaption className="mt-2 font-mono-label text-[8px] text-[#86928a]">{q.who}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
